import axios from 'axios'
import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { payslipFormType } from 'Pages/Frontend/Interface/Admin/PaySlipAdmin/PaySlipAdmin'

AxiosInterceptor()

const paySlipService = {
  async index(pageNumber: number) {
    return await axios.get(`/admin/employee/salary/get-salaries?pageNumber=${pageNumber}`)
  },

  async userPayslipHistory(pageNumber: number, userId: string | undefined) {
    return await axios.get(
      `/admin/employee/salary/get-salaries?pageNumber=${pageNumber}&userId=${userId}`,
    )
  },

  async getPayslipHistory(userId: string | undefined, pageNumber: number) {
    return await axios.get(`/admin/payslip/history?userId=${userId}&pageNumber=${pageNumber}`)
  },

  async getPayslip(employeeId: string | undefined, pageNumber: number) {
    return await axios.get(
      `/admin/employee/salary/get-salaries?id=${employeeId}&pageNumber=${pageNumber}`,
    )
  },

  async getPayslipDetails(userId: string | undefined) {
    return await axios.get(`/admin/payslip?userId=${userId}`)
  },

  async sendPayslipToAll(data: payslipFormType) {
    return await axios.post('/admin/payslip/generate-payslip-for-all', data)
  },

  async sendPayslipToUser(data: { userId: string | undefined; month: string; year: string }) {
    return await axios.get(
      `/admin/payslip?userId=${data.userId}&month=${data.month}&year=${data.year}`,
    )
  },

  async sendCustomPayslipToAll(data: payslipFormType) {
    return await axios.post('/admin/payslip/sendCustomPayslip', data)
  },

  async resendPayslip(payslipID: string) {
    return await axios.post(`/admin/payslip/resend-payslip/${payslipID}`)
  },

  async sendCustomPayslipToUser(data: {
    userId: string | undefined
    earnings:
      {
        category: string
        amount: number
      }[],
    deductions:
      {
        category: string
        amount: number
      }[],
    allowances:
      {
        category: string
        amount: number
      }[],
    relief:
      {
        category: string
        amount: number
      }[],
    month: string
    year: string
  }) {
    return await axios.post('/admin/payslip/sendCustomPayslip', data)
  },
}

export default paySlipService
